export class TramitadorConfiguracionFiltro {
    tipo: boolean;
    legislacion: boolean;
    origen: boolean;
    matricula: boolean;
    fotos: boolean;
}